import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Nav,
  NavItem,
  NavLink,
  TabPane,
  TabContent,
} from "reactstrap";
import Uppy from "@uppy/core";

import Webcam from "@uppy/webcam";
import { Dashboard } from "@uppy/react";
import XHR from "@uppy/xhr-upload";

// import MediaLib from "./MediaLib";
const svgChecked = `<svg aria-hidden="true" focusable="false" width="70" height="70" viewBox="0 0 36 36" class="uppy-c-icon uppy-Dashboard-Item-progressIcon--circle"><circle r="15" cx="18" cy="18" fill="#1bb240"></circle><polygon class="uppy-Dashboard-Item-progressIcon--check" transform="translate(2, 3)" points="14 22.5 7 15.2457065 8.99985857 13.1732815 14 18.3547104 22.9729883 9 25 11.1005634"></polygon></svg>`

const uppy1 = new Uppy({
  inline: true,
  meta: { type: "avatar" },
  restrictions: {
    maxFileSize: 10048576,
    maxNumberOfFiles: 20,
    allowedFileTypes: ["image/*"],
  },
  locale: {
    strings: {
      poweredBy: "Powered by Swanpass",
    },
  },
})
  .use(Webcam)
  .use(XHR, {
    endpoint: "/photos",
    formData: true,
    fieldName: "image",
    headers: {
      "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
        ?.content,
    },
  });

const GalleryModal = (props) => {
  const { maxNumberOfFiles, isOpen, ...restProps } = props;
  const maxOfFiles = maxNumberOfFiles || 30;
  const [query, setQuery] = useState('');
  const [page, setPage] = useState(1);
  const [source, setSource] = useState('venues');
  const [activeTab, setActiveTab] = useState("libs");
  const [photos, setPhotos] = useState([])
  const [meta, setMeta] = useState({})
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [refresh, setRefresh] = useState(0);

  const [selectedPhotos, setSelectedPhotos] = useState([]);

  const handleSelect = (e) => {
    e.preventDefault();
    if (props.onSelectPhoto) {
      props.onSelectPhoto([...selectedPhotos]);
      setSelectedPhotos([]);
    }
  };

  const handleTogglePhoto = (e, photo) => {
    e.preventDefault();
    setSelectedPhotos((selected) => selected.some((item) => item.id === photo.id)
      ? selected.filter((item) => item.id !== photo.id)
      : selected.length < maxOfFiles ? [...selected, photo] : selected);
  }
  const handleBeforeUpload = (file) => {
    if (file.type.includes('image')) {
      const image = new Image();
      image.src = window.URL.createObjectURL(file.data);
      image.onload = () => {
        const resolution = {
          width: image.width,
          height: image.height,
        };
        uppy1.setFileMeta(file.id, {
          width: resolution.width,
          height: resolution.height,
          resolution: resolution,
        });
      };
    }
  };

  useEffect(() => {
    const onUploadSuccess = (_file, response) => {
      setSelectedPhotos((selected) => {
        const remaining = selected.filter((photo) => photo.id !== response.body.id);
        return remaining.length < maxOfFiles ? [...remaining, response.body] : remaining;
      });
    };
    const onComplete = () => {
      setSource('uploads');
      setQuery('');
      setPage(1);
      setRefresh((value) => value + 1);
      setActiveTab('libs');
    };
    uppy1.on('file-added', handleBeforeUpload);
    uppy1.on('upload-success', onUploadSuccess);
    uppy1.on('complete', onComplete);
    return () => {
      uppy1.off('file-added', handleBeforeUpload);
      uppy1.off('upload-success', onUploadSuccess);
      uppy1.off('complete', onComplete);
    };
  }, [maxOfFiles]);

  useEffect(() => {
    if (!isOpen || activeTab !== 'libs') return;
    const controller = new AbortController();
    const timer = setTimeout(async () => {
      setLoading(true);
      setError('');
      try {
        const params = new URLSearchParams({ query, page: String(page) });
        if (source === 'venues') params.set('source', 'venues');
        const response = await fetch(`/photos?${params}`, { signal: controller.signal });
        if (!response.ok) throw new Error('Could not load images');
        const data = await response.json();
        setPhotos(data.photos || []);
        setMeta(data.meta || {});
      } catch (fetchError) {
        if (fetchError.name !== 'AbortError') {
          setPhotos([]);
          setMeta({});
          setError('Could not load images. Please try again.');
        }
      } finally {
        if (!controller.signal.aborted) setLoading(false);
      }
    }, query ? 300 : 0);
    return () => {
      clearTimeout(timer);
      controller.abort();
    };
  }, [isOpen, activeTab, query, page, source, refresh]);

  useEffect(() => {
    if (!isOpen) setSelectedPhotos([]);
  }, [isOpen]);

  useEffect(() => {
    uppy1.setOptions({ restrictions: { maxNumberOfFiles: maxOfFiles } });
  }, [maxOfFiles]);

  const handleCancel = (e) => {
    e.preventDefault();
    props.onCancel()
  }
  const handleChange = (e) => {
    setQuery(e.target.value);
    setPage(1);
  }

  return (
    <Modal
      className="gallery-modal"
      fullscreen
      isOpen={isOpen}
      toggle={handleCancel}
      keyboard={false}
      {...restProps}

    >
      <ModalHeader toggle={e => props.onCancel()}>Media Library</ModalHeader>
      <ModalBody>
        <Nav>
          <NavItem>
            <NavLink
              className={`tab-btn ${activeTab === "upload" ? "active" : ""}`}
              onClick={(e) => setActiveTab("upload")}
            >
              Upload files
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={`tab-btn ${activeTab !== "upload" ? "active" : ""}`}
              onClick={(e) => setActiveTab("libs")}
            >
              Library
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent className="tab-content active" activeTab={activeTab}>
          <TabPane className="tab-pane" tabId="upload">
            <Dashboard
              uppy={uppy1}
              // hideUploadButton={true}
              proudlyDisplayPoweredByUppy={false}
              plugins={["Webcam"]}
            />
          </TabPane>
          <TabPane className="tab-pane" tabId="libs">
            <div className="gallery-library-toolbar">
              <div className="gallery-library-sources" role="group" aria-label="Image source">
                <button type="button" className={`btn ${source === 'venues' ? 'btn-primary' : 'btn-secondary'}`} onClick={() => { setSource('venues'); setQuery(''); setPage(1); }}>Venue images</button>
                <button type="button" className={`btn ${source === 'uploads' ? 'btn-primary' : 'btn-secondary'}`} onClick={() => { setSource('uploads'); setQuery(''); setPage(1); }}>Uploads</button>
              </div>
              <input type="search" name="query" className="form-input" value={query} placeholder={source === 'venues' ? 'Search venue name' : 'Search file name or caption'} aria-label="Search images" onChange={handleChange} />
            </div>
            {error && <p role="alert">{error}</p>}
            {loading && <p role="status">Loading images...</p>}
            {!loading && !error && photos.length === 0 && <p>No images found.</p>}
            <div className='gallery-libs'>
              {
                photos.map((photo) => {
                  const isSelected = selectedPhotos.find((x) => (x.id === photo.id));
                  return (
                    <button type="button" key={photo.id}
                      className={`gallery-thumb ${isSelected ? 'selected' : ''}`}
                      onClick={e => handleTogglePhoto(e, photo)}
                      aria-pressed={!!isSelected}
                      title={photo.venue_name || photo.caption || photo.file_name}
                    >

                      {isSelected && <span className='checked-icon' dangerouslySetInnerHTML={{ __html: svgChecked }}></span>}
                      <img src={photo.image_url} alt={`${photo.caption || photo.file_name}`} />
                    </button>
                  )
                })
              }
            </div>
            {meta.pages > 1 && <nav className="gallery-pagination" aria-label="Media pages">
              <button type="button" className="btn btn-secondary" disabled={page <= 1 || loading} onClick={() => setPage(page - 1)}>Previous</button>
              <span>Page {meta.current_page || page} of {meta.pages} · {meta.total} images</span>
              <button type="button" className="btn btn-secondary" disabled={page >= meta.pages || loading} onClick={() => setPage(page + 1)}>Next</button>
            </nav>}
          </TabPane>
        </TabContent>
      </ModalBody>
      <ModalFooter>
        {
          selectedPhotos.length >= maxOfFiles && <div className="primary-text-color">
            You can only upload/select {maxOfFiles} {maxOfFiles > 1 ? 'files' : 'file'}
          </div>
        }
        <a href="#" className="btn btn-secondary" onClick={handleCancel}>
          Cancel
        </a>
        <button className="btn btn-green"
          disabled={selectedPhotos.length === 0}
          onClick={handleSelect}
        >
          Select
        </button>{" "}

      </ModalFooter>
    </Modal>
  );
};

export default GalleryModal;
